<template>
  <v-card light class="elevation-2">
    <v-toolbar dark elevation="0" color="error">
      <v-toolbar-title>{{ $t("TITLE") }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <p v-for="(paragraph, index) in message" :key="index" v-html="paragraph"></p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ErrorMessageDefault',
  props: {
    error: {
      type: Error,
      default: null
    }
  },
  computed: {
    message () {
      const paragraphs = this.$t('MESSAGE').split('\n')
      return paragraphs
    }
  }
}
</script>

<i18n>
{
  "fr": {
    "TITLE": "Oups...",
    "MESSAGE": "<b>Une erreur est survenue.</b>\n<b>Rafraîchissez la page et si cela ne fonctionne pas, essayer dans quelques minutes.</b>\n<b>Si le problème persiste contacter le support CPU.</b>"
  },
  "en": {
    "TITLE": "Whoops...",
    "MESSAGE": "<b>An error has occurred.</b>\n<b>Refresh the page and if it doesn't work, try again in a few minutes.</b>\n<b>If the problem persists contact CPU support. </b>"
  }
}
</i18n>
